/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCarveOutStatusRequest
 */
export interface UpdateCarveOutStatusRequest {
    /**
     * 
     */
    status: UpdateCarveOutStatusRequestStatusEnum;
    /**
     * Required when status is cancelled.
     */
    comment?: string;
}


/**
 * @export
 */
export const UpdateCarveOutStatusRequestStatusEnum = {
    Ready: 'ready',
    Submitted: 'submitted',
    Approved: 'approved',
    Denied: 'denied',
    Cancelled: 'cancelled',
} as const;
export type UpdateCarveOutStatusRequestStatusEnum = typeof UpdateCarveOutStatusRequestStatusEnum[keyof typeof UpdateCarveOutStatusRequestStatusEnum];


/**
 * Check if a given object implements the UpdateCarveOutStatusRequest interface.
 */
export function instanceOfUpdateCarveOutStatusRequest(value: object): value is UpdateCarveOutStatusRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateCarveOutStatusRequestFromJSON(json: any): UpdateCarveOutStatusRequest {
    return UpdateCarveOutStatusRequestFromJSONTyped(json, false);
}

export function UpdateCarveOutStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCarveOutStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function UpdateCarveOutStatusRequestToJSON(json: any): UpdateCarveOutStatusRequest {
    return UpdateCarveOutStatusRequestToJSONTyped(json, false);
}

export function UpdateCarveOutStatusRequestToJSONTyped(value?: UpdateCarveOutStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'comment': value['comment'],
    };
}

